// extracted by mini-css-extract-plugin
export var orderSummary = "_u0-0";
export var showMoreLessButton = "_u0-1";